<ion-item lines="full">
  <ion-label class="ion-text-wrap">{{ label }}</ion-label>
  <ion-select
    slot="end"
    [value]="selectValue"
    [disabled]="disabled"
    interface="popover"
    [attr.aria-label]="'Service timer for ' + label"
    (ionChange)="onSelectChange($event)"
  >
    <ion-select-option value="off">No timer</ion-select-option>
    @for (s of durationStepSeconds; track s) {
      <ion-select-option [value]="durationOptionValue(s)">{{ durationLabel(s) }}</ion-select-option>
    }
  </ion-select>
</ion-item>
